"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInfoButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const reactstrap_1 = require("reactstrap");
exports.AppInfoButton = (0, styled_components_1.default)(reactstrap_1.Button) `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: rgba(var(--primeiro), 1);
    background-color: #ffffff;
    border: 2px solid rgba(var(--primeiro), .5);
    transition: all .5s;
`;
